<template>
    <div class="Aviso">
        <div class="libe_home_nav" v-if="scroll >= 88">
            <headNav :activeNav="'loan'"></headNav>
        </div>
        <div class="libe_home_wrap">
            <div class="libe_homenav" v-if="scroll < 88 ">
                <headNav :activeNav="'loan'"></headNav>
            </div>

            <div class="arrecredi_home_banner" style="height: 270px;">

            </div>

            <div class="bigContent">
                <div class="content">
                    <div style="width: 100%; height: 60px; font-size: 32px; font-weight: bold; color: #333333;">AVISO DE PRIVACIDAD</div>
                    <p>
                        <span style="font-weight: bolder;">“AVANZARAPIDO”</span>, S.A. DE C.V., (en lo sucesivo, <span style="font-weight: bolder;">“AvanzaRapido”</span>), con domicilio en Privada Hacienda Carbonera número 135, Colonia Haciendas de Tizayuca, municipio de Tizayuca, estado de Hidalgo, C.P. 43815, al momento de recabar tus datos personales, es responsable del uso y protección de los mismos.
                    </p>
                    <p>
                        <span style="font-weight: bolder;">“AvanzaRapido”</span> recabará de Usted (en adelante “el Titular”) los siguientes datos personales (en adelante “Los datos”), en tu calidad de cliente:.
                    </p>
                    <ul>
                        <li>
                            Datos de contacto (número de teléfono celular, correo electrónico y domicilio particular);
                        </li>
                        <li>
                            Datos de identificación (Nombre, fecha de nacimiento, captura de imagen (fotografía), identificación oficial, RFC, CURP, FIEL, y género);
                        </li>
                        <li>
                            Datos biométricos;
                        </li>
                        <li>
                            Datos de localización y geolocalización (Ubicación, huso horario);
                        </li>
                        <li>
                            Datos laborales y de preparación académica;
                        </li>
                        <li>
                            Datos de comunicación con <span style="font-weight: bolder;">“AvanzaRapido”</span> (solicitudes de atención a cliente, resoluciones a aclaraciones u otras comunicaciones a través de mensajes (SMS), correo electrónico o grabación de llamadas telefónicas;
                        </li>
                        <li>
                            Datos de tu dispositivo móvil (información del hardware, IMEI, dirección IP, o cualquier otro dato de identificación del dispositivo);
                        </li>
                        <li>
                            Información bancaria: nombre del banco emisor, número de tarjeta y código de cuenta bancaria (CLABE);
                        </li>
                        <li>
                            Cámara y almacenamiento: se utilizan únicamente para tomar o subir imágenes relacionadas con la solicitud de préstamo y la verificación de identidad. Las fotos seleccionadas manualmente serán cifradas y conservadas por un periodo máximo de un año;
                        </li>
                        <li>
                            Registro de SMS: Solo se leerán los mensajes de texto relacionados con temas financieros (incluyendo fecha, número de teléfono y contenido). No se recopilará información no financiera ni SMS que no cumplan con las reglas de filtrado. Los datos de los SMS recopilados se utilizarán únicamente para análisis de control de riesgos, con el fin de evaluar su elegibilidad para la solicitud de préstamo y determinar si cumple con las condiciones para utilizar nuestros servicios. Solo se capturarán los mensajes recibidos en los últimos 6 meses que contengan, entre otros, las siguientes palabras: “préstamo”, “banco”, “pago”, “crédito”, “adeudo”, etc. Sin su autorización expresa, no accederemos a sus mensajes de texto. Si desea eliminar los datos relacionados, puede enviar un correo electrónico a avanzarpidoservice@gmail.com; su solicitud será atendida en un plazo de 3 a 5 días hábiles;
                        </li>
                        <li>
                            Lista de contactos de tu dispositivo móvil;
                        </li>
                        <li>
                            Datos financieros (ingresos mensuales, grado de escolaridad, uso que se le dará al préstamo);
                        </li>
                        <li>
                            Datos transaccionales de las operaciones que realizas con <span style="font-weight: bolder;">“AvanzaRapido”</span> o a través de, así como de las operaciones que realizas con transacciones de dinero, instituciones de fondos de pago electrónico, instituciones de financiamiento colectivo, instituciones de crédito y otras instituciones financieras o comercios electrónicos;
                        </li>
                    </ul>
                    <p>
                        Los datos personales mencionados anteriormente se enviarán a la interfaz de programación de aplicaciones de <span style="font-weight: bolder;">“AvanzaRapido”</span>.
                    </p>
                    <p style="font-weight: bold;">USO DE DATOS PERSONALES CONSIDERADOS SENSIBLES.  </p>
                    <p>
                        <span style="font-weight: bolder;">“AvanzaRapido”</span> no solicita datos correspondientes a raza u origen étnico, creencias, afiliación a algún sindicato o partido político, preferencias sexuales (salvo por tu género asignado que se requiere para temas de prevención de lavado de dinero). Sin embargo, recabamos información de tu lista de contactos, mensajes de texto, y registro de mensajes de texto o imágenes (MMS o SMS), que pueden contener datos personales sensibles.
                    </p>
                    <p>
                        <span style="font-weight: bolder;">“AvanzaRapido”</span> informa que los datos personales y datos personales sensibles recabados y solicitados, de conformidad con el presente Aviso de Privacidad, son necesarios y suficientes para que <span style="font-weight: bolder;">“AvanzaRapido”</span> realice un proceso de evaluación de riesgo de crédito y probabilidad de pago (score crediticio), con base en tu perfil y así poder determinar tu capacidad crediticia, lo cual es la base fundamental de la determinación para poder aprobar o rechazar la solicitud de otorgamiento de crédito y dar inicio a la relación jurídica, así como para las demás finalidades primarias y secundarias que se señalan en el presente Aviso de Privacidad. La decisión final no es tomada de forma manual por un empleado de <span style="font-weight: bolder;">“AvanzaRapido”</span>, dicha decisión es tomada por los sistemas automatizados, propiedad de “AvanzaRapido”.
                    </p>
                    <p style="font-weight: bold;">OBTENCIóN DE LOS DATOS PERSONALES.</p>
                    <p>Los datos personales serán obtenidos y actualizados a través de:</p>
                    <ul>
                        <li>
                            Cuando descargas la aplicación de MoneyMex y/o solicitas un préstamo;
                        </li>
                        <li>
                            Cuando realices interacción con <span style="font-weight: bolder;">“AvanzaRapido”</span>, incluyendo datos personales que voluntariamente compartes con nuestro departamento de atención al cliente o con nuestros empleados;
                        </li>
                        <li>
                            Tu teléfono celular o dispositivo móvil cuando otorgas acceso y permisos a la aplicación;
                        </li>
                        <li>
                            Burós de crédito o agencias;
                        </li>
                        <li>
                            Cookies u otros medios remotos de recolección automática de datos;
                        </li>
                        <li>
                            Transmisores de dinero, instituciones de fondos de pago electrónico, instituciones de financiamiento colectivo, instituciones de crédito y otras instituciones financieras y comercios electrónicos, con tu consentimiento, cuando sea necesario;
                        </li>
                        <li>
                            Terceros y otras fuentes públicas con tu consentimiento.
                        </li>
                    </ul>
                    <p style="font-weight: bold;">USO DE LOS DATOS.</p>
                    <p>
                        Las finalidades que dan origen y son necesarias para el mantenimiento y cumplimiento de la relación jurídica entre <span style="font-weight: bolder;">“AvanzaRapido”</span> y “el Titular”, son las siguientes:
                    </p>
                    <ul>
                        <li>
                            Verificar la identidad de “el Titular”, para prevenir fraudes y cumplir con nuestras obligaciones en materia de lavado de dinero;
                        </li>
                        <li>
                            Crear el perfil crediticio de “el Titular” y asignar una calificación crediticia, para determinar si eres elegible para usar los productos y servicios de <span style="font-weight: bolder;">“AvanzaRapido”</span>;
                        </li>
                        <li>
                            Llevar a cabo la identificación y el conocimiento mediante recolección de datos personales, así como la integración de su expediente que se mantendrá en la infraestructura tecnológica y sistemas de <span style="font-weight: bolder;">“AvanzaRapido”</span>.
                        </li>
                        <li>
                            Incorporar los datos personales en instrumentos jurídicos, dar cumplimiento a los contratos que celebres con <span style="font-weight: bolder;">“AvanzaRapido”</span>, incluyendo, de manera enunciativa mas no limitativa a ciertos contratos de usuario de nuestra aplicación y plataformas y los contratos de préstamo o crédito simple entre “el Titular” y <span style="font-weight: bolder;">“AvanzaRapido”</span>, y administrar y manejar dichos contratos;
                        </li>
                        <li>
                            Brindar servicios y gestionar tu cuenta con <span style="font-weight: bolder;">“AvanzaRapido”</span> y darte soporte como cliente;
                        </li>
                        <li>
                            Enviarte información de transacciones o notificaciones de transacciones, recordatorios de pago y anuncios a través de servicios de telefonía automáticos o mensajes pre-grabados, mensajes de texto o correo electrónico;
                        </li>
                        <li>
                            Ceder o transmitir a un tercero, mediante cualquier medio, los derechos y/u obligaciones derivadas de los contratos antes señalados;
                        </li>
                        <li>
                            Utilizar los datos personales, en cualquier tipo de acto o diligencia de cobranza judicial o extrajudicial;
                        </li>
                        <li>
                            Cumplir con todas las leyes, reglamento y disposiciones de carácter general aplicables;
                        </li>
                        <li>
                            Investigar cambios en tu perfil transaccional y prevención de fraudes;
                        </li>
                        <li>
                            Obtener datos personales para mejorar los modelos crediticios de <span style="font-weight: bolder;">“AvanzaRapido”</span>, sus modelos de datos y otros servicios;
                        </li>
                        <li>
                            Analizar el comportamiento del cliente y mantener la calidad de nuestros servicios.
                        </li>
                    </ul>
                    <p style="font-weight: bold;">TRANSFERENCIA DE DATOS PERSONALES. </p>
                    <p>Los datos personales se transferirán a nivel nacional e internacional a:</p>
                    <ul>
                        <li>
                            Otras sociedades controladoras, subsidiarias o afiliadas, o a una sociedad matriz o cualquier sociedad del mismo grupo de <span style="font-weight: bolder;">“AvanzaRapido”</span>, que operen bajo los mismos procesos y políticas internas, con la finalidad de hacer uso de servicios compartidos dentro del grupo de <span style="font-weight: bolder;">“AvanzaRapido”</span>;
                        </li>
                        <li>
                            A autoridades nacionales y extranjeras competentes, con la finalidad de dar cumplimiento a alguna ley, reglamento o disposición legal aplicable, así como con la finalidad de prevenir un daño;
                        </li>
                        <li>
                            A terceros que adquieran la cartera crediticia de <span style="font-weight: bolder;">“AvanzaRapido”</span> o que otorguen financiamiento a la misma, con la finalidad de que la empresa pueda obtener financiamiento o recursos;
                        </li>
                        <li>
                            A terceros interesados en otorgar financiamiento o adquirir las acciones o activos de <span style="font-weight: bolder;">“Avanzarapido”</span>, o de sus accionistas en México;
                        </li>
                        <li>
                            Con nuestros socios comerciales, para fines de prospección comercial y servicios relacionados ofrecidos con <span style="font-weight: bolder;">“AvanzaRapido”</span>, y para dar acceso a los servicios de terceros dentro de la aplicación de <span style="font-weight: bolder;">“AvanzaRapido”</span>;
                        </li>
                    </ul>
                    <p style="font-weight: bold;">CONSENTIMIENTO DE TRANSFERENCIA. </p>
                    <p>
                        Considera que no será necesario obtener tu consentimiento para llevar a cabo la transferencia de datos indicada anteriormente en los números I y II, por encontrarse en el supuesto establecido en la fracción IV del artículo 37 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, y aquellas transferencias que se encuentren dentro de los supuestos establecidos en el artículo 37 de la misma Ley. Tampoco requerimos tu consentimiento para compartir tus datos personales con encargados como los prestadores de servicios mencionados anteriormente.
                    </p>
                    <p>
                        Para llevar a cabo las transferencias de datos de los números III, IV y V de la sección anterior, sí requerimos tu consentimiento, el cual otorgas al aceptar el presente Aviso de Privacidad.
                    </p>
                    <p style="font-weight: bold;">DERECHOS ARCO. </p>
                    <p>
                        Por tu propio derecho, o mediante tu representante legal, puedes ejercer tus derechos de Acceso, Rectificación, Cancelación u Oposición (los derechos ARCO). Para ello podrás solicitar un formato de ejercicio de derechos ARCO mediante el envío de un correo electrónico a la dirección de correo: avanzarpidoservice@gmail.com, o en el departamento de Atención al Cliente, o bien, en la dirección de <span style="font-weight: bolder;">“AvanzaRapido”</span> indicada en este Aviso con el nombre y los datos de contacto de “el Titular”.
                    </p>
                    <p style="font-weight: bold;">NEGATIVA O REVOCACIÓN DEL CONSENTIMIENTO PARA EL TRATAMIENTO DE DATOS PERSONALES. </p>
                    <p>
                        En caso de que desees revocar tu consentimiento o negarte al tratamiento de tus datos personales para finalidades distintas a las establecidas en el presente Aviso, deberás enviar un correo electrónico a la dirección indicada en la sección anterior o al departamento de Atención al Cliente, siguiendo el procedimiento para la negativa al tratamiento y/o Revocación del Consentimiento que se describe en este aviso.
                    </p>
                    <p style="font-weight: bold;">ELIMINACION DE LA CUENTA. </p>
                    <p>Puedes solicitar el cierre y la eliminación de tu cuenta en la aplicación, enviándonos un correo electrónico a avanzarpidoservice@gmail.com. <span style="font-weight: bolder;">“AvanzaRapido”</span> se reserva el derecho a denegar la solicitud cuando ésta no pueda verificarse, cuando su cuenta tenga un saldo pendiente derivado de un préstamo o esté siendo investigada, o cuando exista cualquier otra base legal para conservar u cuenta y los datos asociados a dicha cuenta.</p>
                    <p>En virtud de la regulación en materia de prevención de lavado de dinero, <span style="font-weight: bolder;">“AvanzaRapido”</span> está obligado a conservar la información de sus clientes durante al menos 5 (cinco) años. A pesar de las solicitudes de eliminación de una cuenta, <span style="font-weight: bolder;">“AvanzaRapido”</span> conservará los registros de información del cliente (tales como: información del perfil del PLD, registros de identificación y registros de transacciones) hasta que el periodo de retención legal haya expirado.</p>
                    <p style="font-weight: bold;">CAMBIOS AL PRESENTE AVISO DE PRIVACIDAD.</p>
                    <p>
                        El presente Aviso se encuentra publicado para su consulta, en la página de internet de <span style="font-weight: bolder;">“AvanzaRapido”</span> (https://www.moneymex.mx). De igual forma, las modificaciones que se realicen al presente Aviso, serán publicadas en dicha dirección. Al Aceptar el presente, “el Titular” otorga su consentimiento expreso en términos del presente Aviso y por ende, consiente que sus datos personales sean tratados por <span style="font-weight: bolder;">“AvanzaRapido”</span> conforme a lo previsto en el presente Aviso, destinados para las finalidades indicadas en el presente y transferidos a terceros aquí indicados.
                    </p>
                </div>
            </div>
        </div>
        <footPage></footPage>
    </div>
</template>

<script>

    import $ from 'jquery';
    import headNav from "@/components/headNav.vue";
    import footPage from "@/components/foot.vue";
    import "../components/scss/Aviso.scss";

    export default {
        name: "loan",
        components: { headNav, footPage },
        data() {
            return {
                scroll: 0,
                activeName: 'first',
            }
        },
        mounted(){
            document.documentElement.scrollTop = 0;
            window.addEventListener('scroll',this.handleScroll);
            if(this.$route.query.activeName){
                this.activeName = this.$route.query.activeName;
            }
            this.$nextTick(() => {
                $('.el-tabs__active-bar').css({
                    width: '150px'
                })
            });


        },
        methods: {
            handleClick(tab, event){
                console.log(tab)
                console.log(event)
                this.$nextTick(() => {
                    setTimeout(() => {
                        $('.el-tabs__active-bar').css({
                            width: '150px'
                        })
                    }, 100)
                });
            },
            handleScroll(){
                this.scroll = document.documentElement.scrollTop||document.body.scrollTop
            },
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll)
        }
    }
</script>

<style>
    .title p span {
        border-bottom: 3px solid #4e67f1;
    }
    .arrecredi_home_banner{
        width: 100%;
        height: 402px;
        position: relative;
        overflow: hidden;
        z-index: 2;
    }
    .bigContent .el-tabs__item{
        height: 58px;
        font-weight: bold;
        font-size: 32px;
        color: #262A48;
    }
    .bigContent .el-tabs__item:hover{
        color: #262A48;
    }
    .bigContent .el-tabs__active-bar{
        height: 3px;
        background: #262A48;
    }
    .bigContent .el-tabs__item.is-active{
        color: #262A48;
    }
    .bigContent .el-tabs__nav-wrap::after{
        height: 0;
    }
    #tab-first{
        width: 495px;
    }
    .arrecrediprivacidad_view{
        width: 100%;
        padding: 50px 0 0 0;
    }
</style>

